document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.js-team-member').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      showOverlay(el);
    });
  });
  document.querySelectorAll('.js-team-close').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      // hide all overlays
      document.querySelectorAll('.js-team-overlay')
        .forEach(el => el.classList.add('is-hidden'));
    });
  });
});

const showOverlay = function (el) {
  // hide all overlays
  document.querySelectorAll('.js-team-overlay')
    .forEach(el => el.classList.add('is-hidden'));
  // get team member id
  const currentId = el.dataset.id;
  // show overlay for this team member
  document.getElementById(`${currentId}`).classList.remove('is-hidden');
};